import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';

import { resolveValue } from '@lvflanders/bar';

import { BarActionButton } from '../../../bar-action-button/bar-action-button';
import { BarActionButtonOptions } from '../../../bar-action-button/bar-action-button-options.model';
import { _BarControlsHelper } from '../../../shared/bar-controls.helper';

@Component({
    selector: 'bar-meer-acties',
    templateUrl: './bar-meer-acties.component.html',
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AsyncPipe, NgClass, MatButtonModule, MatMenuModule, MatTooltipModule, NgTemplateOutlet, BarActionButton]
})
export class BarMeerActiesComponent {
    readonly controlsHelper = inject(_BarControlsHelper);
    readonly #router = inject(Router);

    readonly top = input<boolean>(undefined);
    readonly items = input<BarActionButtonOptions[]>(undefined);
    moreActionsButton: BarActionButtonOptions;

    constructor() {
        this.moreActionsButton = {
            title: 'Meer acties',
            icon: {
                class: 'fas fa-ellipsis-h',
                srText: 'Meer acties',
                iconOnly: true
            }
        };
    }

    menuItemClicked(event, item: BarActionButtonOptions) {
        if (item.action) item.action();

        if (item.routerLink) this.#router.navigate(resolveValue(item.routerLink));

        if (item.routerUrl) this.#router.navigateByUrl(resolveValue(item.routerUrl));

        if (item.href) window.open(resolveValue(item.href), resolveValue(item.target));
    }
}
